import { render } from "./Hello.vue?vue&type=template&id=77fc6b70"
import script from "./Hello.vue?vue&type=script&lang=ts"
export * from "./Hello.vue?vue&type=script&lang=ts"

import "./Hello.vue?vue&type=style&index=0&id=77fc6b70&rel=stylesheet&lang=scss"
script.render = render

export default script